import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import apiService from '../../services/api';

const SendNotificationModal = ({ po, sale, onClose, onSuccess }) => {
  const item = sale || po;
  const status = item?.status || item?.apiData?.status;
  const subStatus = item?.sub_status || item?.apiData?.sub_status;
  const isQuotation = status === 'draft' && (subStatus === 'quotation' || item?.is_quotation == 1 || item?.apiData?.is_quotation == 1 || item?.is_quotation === true);
  const isSale = !isQuotation && (Boolean(sale) || item?.type === 'sell' || item?.apiData?.type === 'sell');
  const templateFor = isQuotation ? 'new_quotation' : (isSale ? 'new_sale' : 'purchase_order');

  const [emailOpen, setEmailOpen] = useState(true);
  const [smsOpen, setSmsOpen] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const defaultSubject = isQuotation
    ? `Thank you from {business_name}`
    : (isSale
      ? `New Sale, from {business_name}`
      : `New Purchase Order, from {business_name}`);

  const defaultEmailBody = isQuotation
    ? `Dear {contact_name},\n\nYour quotation number is {invoice_number}\nTotal amount: {total_amount}\n\nThank you for shopping with us.\n\n{business_logo}`
    : (isSale
      ? `Dear {contact_name},\n\nWe have a new sale with invoice number {invoice_no}. The respective Invoice is attached here with.\n\n{business_logo}`
      : `Dear {contact_name},\n\nWe have a new purchase order with reference number {order_ref_number}. The respective Invoice is attached here with.\n\n{business_logo}`);

  const [form, setForm] = useState({
    send_email: true,
    to_email: item?.email || item?.contact?.email || item?.customer_email || '',
    subject: defaultSubject,
    cc: '',
    bcc: '',
    email_body: defaultEmailBody,
    attach_pdf: false,

    send_sms: false,
    send_whatsapp: false,
    mobile_number: item?.mobile || item?.contact?.mobile || item?.customer_mobile || '',
    sms_body: isQuotation
      ? `Dear {contact_name}, Thank you for shopping with us. {business_name}`
      : (isSale
        ? `Sale {invoice_no} total: {total_amount}`
        : `Purchase Order {order_ref_number} total: {final_total}`),
    whatsapp_text: isQuotation
      ? `Quotation {invoice_number} details`
      : (isSale
        ? `Sale {invoice_no} details`
        : `Purchase Order {order_ref_number} details`)
  });

  useEffect(() => {
    const fetchTemplate = async () => {
      if (!item?.id) return;
      setIsLoading(true);
      try {
        const res = await apiService.getNotificationTemplate(item.id, templateFor);
        if (res && res.success) {
          const tpl = res.notification_template || {};
          const contact = res.contact || {};

          setForm((prev) => ({
            ...prev,
            to_email: contact.email || prev.to_email,
            mobile_number: contact.mobile || prev.mobile_number,
            subject: tpl.subject || prev.subject,
            email_body: tpl.email_body || prev.email_body,
            sms_body: tpl.sms_body || prev.sms_body,
            whatsapp_text: tpl.whatsapp_text || prev.whatsapp_text,
            cc: tpl.cc || prev.cc,
            bcc: tpl.bcc || prev.bcc,
            attach_pdf: tpl.auto_send_pdf ? true : prev.attach_pdf
          }));
        }
      } catch (err) {
        console.error('Error loading notification template:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTemplate();
  }, [item, templateFor]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);

    const notificationTypes = [];
    if (form.send_email) notificationTypes.push('email');
    if (form.send_sms) notificationTypes.push('sms');
    if (form.send_whatsapp) notificationTypes.push('whatsapp');

    if (notificationTypes.length === 0) {
      toast.error('Please select at least one notification channel (Email, SMS, or WhatsApp)');
      setIsSending(false);
      return;
    }

    try {
      const payload = {
        transaction_id: item.id,
        template_for: templateFor,
        notification_type: notificationTypes,
        to_email: form.to_email,
        subject: form.subject,
        cc: form.cc,
        bcc: form.bcc,
        email_body: form.email_body,
        attach_pdf: form.attach_pdf ? 1 : 0,
        mobile_number: form.mobile_number,
        sms_body: form.sms_body,
        whatsapp_text: form.whatsapp_text
      };

      const res = await apiService.sendNotification(payload);
      if (res && res.success !== false) {
        toast.success(res?.msg || 'Notification sent successfully');
        if (res.whatsapp_link) {
          window.open(res.whatsapp_link, '_blank');
        }
        if (onSuccess) onSuccess();
        onClose();
      } else {
        toast.error(res?.msg || res?.message || 'Failed to send notification');
      }
    } catch (err) {
      toast.error(err.message || 'Failed to send notification');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose} style={{ zIndex: 99999 }}>
      <div
        className="modal-container"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '650px', width: '92%', borderRadius: '6px', overflow: 'hidden', backgroundColor: '#ffffff', boxShadow: '0 10px 25px rgba(0,0,0,0.2)' }}
      >
        {/* Modal Header */}
        <div
          className="modal-header"
          style={{
            display: 'flex',
            justify: 'space-between',
            alignItems: 'center',
            padding: '0.85rem 1.25rem',
            borderBottom: '1px solid #e5e7eb',
            background: '#ffffff'
          }}
        >
          <h4 style={{ fontSize: '1.15rem', fontWeight: '600', margin: 0, color: '#111827' }}>
            {isQuotation
              ? 'Send Notification - New Quotation'
              : (isSale ? 'Send Notification - New Sale' : 'Send Notification - Purchase Order')}
          </h4>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', fontSize: '1.4rem', cursor: 'pointer', color: '#9ca3af', lineHeight: 1 }}
          >
            ×
          </button>
        </div>

        {/* Modal Body */}
        <form onSubmit={handleSubmit}>
          <div className="modal-body" style={{ padding: '1.25rem', maxHeight: '72vh', overflowY: 'auto' }}>
            {/* Available Tags Header */}
            <div style={{ marginBottom: '1.25rem', fontSize: '0.82rem', color: '#374151', lineHeight: 1.55 }}>
              <strong style={{ color: '#111827' }}>Available Tags:</strong>
              <div style={{ color: '#6b7280', marginTop: '0.2rem' }}>
                <div>{'{business_name}'}, {'{business_logo}'}</div>
                {isQuotation ? (
                  <div>{'{invoice_number}'}, {'{total_amount}'}, {'{quote_url}'}</div>
                ) : isSale ? (
                  <div>{'{invoice_no}'}, {'{total_amount}'}, {'{paid_amount}'}, {'{due_amount}'}, {'{cumulative_due}'}, {'{due_date}'}</div>
                ) : (
                  <div>{'{order_ref_number}'}</div>
                )}
                <div>{'{location_name}'}, {'{location_address}'}, {'{location_email}'}, {'{location_phone}'}, {'{location_custom_field_1}'}, {'{location_custom_field_2}'}, {'{location_custom_field_3}'}, {'{location_custom_field_4}'}</div>
                <div style={{ wordBreak: 'break-word' }}>
                  {'{contact_name}'}, {'{contact_custom_field_1}'}, {'{contact_custom_field_2}'}, {'{contact_custom_field_3}'}, {'{contact_custom_field_4}'}, {'{contact_custom_field_5}'}, {'{contact_custom_field_6}'}, {'{contact_custom_field_7}'}, {'{contact_custom_field_8}'}, {'{contact_custom_field_9}'}, {'{contact_custom_field_10}'}
                </div>
              </div>
            </div>

            {/* Accordion 1: Send Email */}
            <div style={{ border: '1px solid #e5e7eb', borderRadius: '4px', marginBottom: '1rem', overflow: 'hidden' }}>
              <div
                onClick={() => setEmailOpen(!emailOpen)}
                style={{
                  padding: '0.75rem 1rem',
                  background: '#ffffff',
                  borderBottom: emailOpen ? '1px solid #e5e7eb' : 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  justify: 'space-between',
                  alignItems: 'center'
                }}
              >
                <span style={{ fontWeight: '600', color: '#2563eb', fontSize: '0.92rem' }}>
                  Send Email
                </span>
                <span style={{ fontSize: '0.8rem', color: '#9ca3af' }}>{emailOpen ? '▲' : '▼'}</span>
              </div>

              {emailOpen && (
                <div style={{ padding: '1rem', background: '#fafafa', display: 'flex', flexDirection: 'column', gap: '0.85rem' }}>
                  <div>
                    <label style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.85rem', color: '#1f2937', cursor: 'pointer', fontWeight: '500' }}>
                      <input
                        type="checkbox"
                        checked={form.send_email}
                        onChange={(e) => handleChange('send_email', e.target.checked)}
                      />
                      Send Email
                    </label>
                  </div>

                  {form.send_email && (
                    <>
                      <div>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', fontSize: '0.82rem', fontWeight: '600', color: '#374151', marginBottom: '0.25rem' }}>
                          To:
                          <span title="Recipient email address" style={{ cursor: 'pointer', color: '#3b82f6', fontSize: '0.78rem' }}>ℹ️</span>
                        </label>
                        <input
                          type="text"
                          value={form.to_email}
                          onChange={(e) => handleChange('to_email', e.target.value)}
                          placeholder="To"
                          style={{ width: '100%', padding: '0.45rem 0.65rem', borderRadius: '4px', border: '1px solid #d1d5db', fontSize: '0.875rem' }}
                        />
                      </div>

                      <div>
                        <label style={{ display: 'block', fontSize: '0.82rem', fontWeight: '600', color: '#374151', marginBottom: '0.25rem' }}>Email Subject:</label>
                        <input
                          type="text"
                          value={form.subject}
                          onChange={(e) => handleChange('subject', e.target.value)}
                          placeholder="Email Subject"
                          style={{ width: '100%', padding: '0.45rem 0.65rem', borderRadius: '4px', border: '1px solid #d1d5db', fontSize: '0.875rem' }}
                        />
                      </div>

                      <div style={{ display: 'flex', gap: '0.75rem' }}>
                        <div style={{ flex: 1 }}>
                          <label style={{ display: 'block', fontSize: '0.82rem', fontWeight: '600', color: '#374151', marginBottom: '0.25rem' }}>CC:</label>
                          <input
                            type="email"
                            value={form.cc}
                            onChange={(e) => handleChange('cc', e.target.value)}
                            placeholder="CC"
                            style={{ width: '100%', padding: '0.45rem 0.65rem', borderRadius: '4px', border: '1px solid #d1d5db', fontSize: '0.875rem' }}
                          />
                        </div>
                        <div style={{ flex: 1 }}>
                          <label style={{ display: 'block', fontSize: '0.82rem', fontWeight: '600', color: '#374151', marginBottom: '0.25rem' }}>BCC:</label>
                          <input
                            type="email"
                            value={form.bcc}
                            onChange={(e) => handleChange('bcc', e.target.value)}
                            placeholder="BCC"
                            style={{ width: '100%', padding: '0.45rem 0.65rem', borderRadius: '4px', border: '1px solid #d1d5db', fontSize: '0.875rem' }}
                          />
                        </div>
                      </div>

                      <div>
                        <label style={{ display: 'block', fontSize: '0.82rem', fontWeight: '600', color: '#374151', marginBottom: '0.25rem' }}>Email Body:</label>
                        <textarea
                          rows="5"
                          value={form.email_body}
                          onChange={(e) => handleChange('email_body', e.target.value)}
                          placeholder="Email Body"
                          style={{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #d1d5db', fontFamily: 'inherit', fontSize: '0.85rem' }}
                        />
                      </div>

                      <div>
                        <label style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.82rem', color: '#374151', cursor: 'pointer' }}>
                          <input
                            type="checkbox"
                            checked={form.attach_pdf}
                            onChange={(e) => handleChange('attach_pdf', e.target.checked)}
                          />
                          Attach PDF in Email
                        </label>
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>

            {/* Accordion 2: Send SMS / WhatsApp Notification */}
            <div style={{ border: '1px solid #e5e7eb', borderRadius: '4px', overflow: 'hidden' }}>
              <div
                onClick={() => setSmsOpen(!smsOpen)}
                style={{
                  padding: '0.75rem 1rem',
                  background: '#ffffff',
                  borderBottom: smsOpen ? '1px solid #e5e7eb' : 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  justify: 'space-between',
                  alignItems: 'center'
                }}
              >
                <span style={{ fontWeight: '600', color: '#0284c7', fontSize: '0.92rem' }}>
                  Send sms/whatsapp notification
                </span>
                <span style={{ fontSize: '0.8rem', color: '#9ca3af' }}>{smsOpen ? '▲' : '▼'}</span>
              </div>

              {smsOpen && (
                <div style={{ padding: '1rem', background: '#fafafa', display: 'flex', flexDirection: 'column', gap: '0.85rem' }}>
                  <div style={{ display: 'flex', gap: '1.5rem' }}>
                    <label style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.85rem', color: '#1f2937', cursor: 'pointer', fontWeight: '500' }}>
                      <input
                        type="checkbox"
                        checked={form.send_sms}
                        onChange={(e) => handleChange('send_sms', e.target.checked)}
                      />
                      Send SMS
                    </label>
                    <label style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.85rem', color: '#1f2937', cursor: 'pointer', fontWeight: '500' }}>
                      <input
                        type="checkbox"
                        checked={form.send_whatsapp}
                        onChange={(e) => handleChange('send_whatsapp', e.target.checked)}
                      />
                      Send Whatsapp notification
                    </label>
                  </div>

                  <div>
                    <label style={{ display: 'block', fontSize: '0.82rem', fontWeight: '600', color: '#374151', marginBottom: '0.25rem' }}>Mobile Number:</label>
                    <input
                      type="text"
                      value={form.mobile_number}
                      onChange={(e) => handleChange('mobile_number', e.target.value)}
                      placeholder="Mobile Number"
                      style={{ width: '100%', padding: '0.45rem 0.65rem', borderRadius: '4px', border: '1px solid #d1d5db', fontSize: '0.875rem' }}
                    />
                  </div>

                  {form.send_sms && (
                    <div>
                      <label style={{ display: 'block', fontSize: '0.82rem', fontWeight: '600', color: '#374151', marginBottom: '0.25rem' }}>SMS Body:</label>
                      <textarea
                        rows="4"
                        value={form.sms_body}
                        onChange={(e) => handleChange('sms_body', e.target.value)}
                        placeholder="SMS Body"
                        style={{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #d1d5db', fontFamily: 'inherit', fontSize: '0.85rem' }}
                      />
                    </div>
                  )}

                  {form.send_whatsapp && (
                    <div>
                      <label style={{ display: 'block', fontSize: '0.82rem', fontWeight: '600', color: '#374151', marginBottom: '0.25rem' }}>Whatsapp Text:</label>
                      <textarea
                        rows="4"
                        value={form.whatsapp_text}
                        onChange={(e) => handleChange('whatsapp_text', e.target.value)}
                        placeholder="Whatsapp Text"
                        style={{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #d1d5db', fontFamily: 'inherit', fontSize: '0.85rem' }}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Modal Footer */}
          <div
            className="modal-footer"
            style={{
              padding: '0.75rem 1.25rem',
              borderTop: '1px solid #e5e7eb',
              display: 'flex',
              justify: 'flex-end',
              gap: '0.6rem',
              background: '#ffffff'
            }}
          >
            <button
              type="submit"
              disabled={isSending}
              style={{
                backgroundColor: '#5850ec',
                color: 'white',
                border: 'none',
                padding: '0.5rem 1.35rem',
                borderRadius: '4px',
                fontWeight: '600',
                cursor: 'pointer',
                fontSize: '0.875rem',
                opacity: isSending ? 0.7 : 1
              }}
            >
              {isSending ? 'Sending...' : 'Send'}
            </button>
            <button
              type="button"
              onClick={onClose}
              style={{
                backgroundColor: '#374151',
                color: 'white',
                border: 'none',
                padding: '0.5rem 1.25rem',
                borderRadius: '4px',
                fontWeight: '600',
                cursor: 'pointer',
                fontSize: '0.875rem'
              }}
            >
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SendNotificationModal;
